import { LitElement, html, css } from 'lit'

class Modal extends LitElement {
  static styles = css`
    :host([open]) {
      display: flex;
      justify-content: center;
      position: absolute;
      inset: var(--overlay-offset, 91px) 0 0 0;
      z-index: 1001;
    }
    dialog {
      display: block;
      background: none;
      border: none;
      padding: 0;
      margin: 0;
      box-sizing: border-box;
      position: static;
      width: 100%;
      background: #fff;
      z-index: 1002;
    }
    .inner {
      margin-left: auto;
      margin-right: auto;
      max-width: var(--site-max-w);
      width: 100%;
      padding: 0 var(--site-padding-x);
      box-sizing: content-box;
      position: relative;
    }
    button {
      position: absolute;
      right: -1rem;
      top: 1.1rem;
      width: 2rem;
      height: 2rem;
      border-radius:1rem;
      appearance: none;
      border: none;
      background: none;
      transition: background 150ms ease-in-out;
      cursor: pointer;
      display: flex;
      padding:0;
      align-items: center;
      justify-content: center;
      color: var(--overlay-close-color, #000);
      --icon-width: 1rem;
      --icon-stroke-width: 2.5;
      --icon-offset: 1px;
    }
    button:hover {
      background:hsl(var(--theme-40));
    }
  `
  static properties = {
    open: { type: Boolean, reflect: true },
  }
  constructor() {
    super()
    this.handleEscPress = this.handleEscPress.bind(this)
    this.handleTriggerClick = this.handleTriggerClick.bind(this)
    // this.handleTriggerKeyDown = this.handleTriggerKeyDown.bind(this)
    this.closeDialog = this.closeDialog.bind(this)
    this._trigger = document.querySelector(
      `[data-controls="${this.getAttribute('id')}"]`
    )
    this._menuContainer = document.querySelector('desktop-menu')
    this.initTrigger()
  }
  updated(changedProperties) {
    if (changedProperties.has('open')) {
      if (this.open) {
        this.initDialog()
      }
    }
  }
  initTrigger() {
    this._trigger.setAttribute('aria-controls', this.getAttribute('id'))
    this._trigger.setAttribute('aria-haspopup', 'true')
    this._trigger.setAttribute('aria-expanded', 'false')

    this._trigger.addEventListener('click', this.handleTriggerClick.bind(this))

    if (this._trigger.tagName.toLowerCase() !== 'button') {
      this._trigger.setAttribute('role', 'button')
      // this.setTriggerKeydownEvents()
    }
  }
  // setTriggerKeydownEvents() {
  //   this._trigger.addEventListener('focus', (e) => {
  //     window.addEventListener('keydown', this.handleTriggerKeyDown)
  //   })
  //   this._trigger.addEventListener('blur', (e) => {
  //     window.removeEventListener('keydown', this.handleTriggerKeyDown)
  //   })
  // }

  initDialog() {
    this.open = true
    this._trigger.setAttribute('aria-expanded', 'true')
    this.dispatchEvent(new CustomEvent('modal-opening', { bubbles: true }))
    setTimeout(() => {
      document.addEventListener('click', this.closeDialog)
      window.addEventListener('keyup', this.handleEscPress)
      this.dispatchEvent(new CustomEvent('modal-opened', { bubbles: true }))
    })
  }
  closed() {
    document.removeEventListener('click', this.closeDialog)
    window.removeEventListener('keyup', this.handleEscPress)
    this.dispatchEvent(new CustomEvent('modal-closed', { bubbles: true }))
  }
  closeDialog() {
    this._trigger.setAttribute('aria-expanded', 'false')
    this.dispatchEvent(new CustomEvent('modal-closing', { bubbles: true }))
    setTimeout(
      () => {
        this.closed()
        this.open = false
      },
      this._menuContainer.state !== 'open' ? 500 : 0
    )
  }
  handleTriggerClick(e) {
    e.preventDefault()
    this.open ? this.closeDialog() : (this.open = true)
  }
  // handleTriggerKeyDown(e) {
  //   if (e.key === ' ' || e.key === 'Spacebar') {
  //     e.preventDefault()
  //     e.target.click()
  //   }
  // }
  handleEscPress(e) {
    if (e.key === 'Escape') {
      this.closeDialog()
    }
  }
  render() {
    if (!this.open) return

    return html`
      <dialog part="dialog" open @click="${(e) => e.stopPropagation()}">
        <div class="inner">
          <button
            @click="${this.closeDialog}"
            aria-label="Stäng"
            part="close-button"
          >
            <close-icon></close-icon>
          </button>
          <slot></slot>
        </div>
      </dialog>
    `
  }
}
customElements.define('desktop-menu-modal', Modal)
